import CompanySwitchList from './CompanySwitchList'

export default CompanySwitchList
